import styled, { keyframes } from "styled-components";

interface HeadCellProps {
  width?: string;
}
export const HeadCell = styled.th<HeadCellProps>`
  width: ${({ width }) => width ?? "auto"};
  padding: 0.5rem;
  background-color: #024872;
  position: relative;
`;

export const Content = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  text-align: left;
  vertical-align: baseline;
  align-items: center;
  color: #fff;
  font-weight: 400;
  width: 100%;
  gap: 0.5rem;
`;

export const DotsContainer = styled.div`
  position: relative;

  button {
    font-size: 1.1rem;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    color: white;
    display: flex;
    align-items: center;
    border-radius: 0.25rem;

    &:hover {
      cursor: pointer;
      background-color: #fff3;
    }
  }

  .btn-filter {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.primaryBlue.main};
    color: #fff;
    border-radius: 0.25rem;
    padding: 0.125rem 0;
    font-size: 1rem;
    &:hover {
      background-color: ${({ theme }) => theme.colors.primaryBlue.hover};
    }
  }

  .btn-clear {
    font-size: 0.9rem;
    background-color: #fff;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    border: 1px solid ${({ theme }) => theme.colors.primaryBlue.main};
    &:hover {
      background-color: #f8f8f8;
    }
  }

  .separator {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    font-weight: bold;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryBlue.main};
    margin: 0.5rem 0;
    padding: .2rem 0.5rem;
    &:hover {
      background-color: transparent;
      cursor: default;
    }
  }
`;

const SlideDownFade = keyframes`
    from {
        opacity: 0;
        transform: translate(-0.5rem, -0.5rem);
    }
    to {
        opacity: 1;
        transform: translate(-0.5rem, 0.5rem);
    }
`;

export const ListContainer = styled.div<{negativeMargin: string}>`
  position: absolute;
  transform: translate(-0.5rem, 0.5rem);
  animation: ${SlideDownFade} 0.3s ease-in-out;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px #2225;
  border-radius: 0.5rem;
  z-index: 15;
  margin-left: ${({negativeMargin}) => negativeMargin ?? "0"};

  ul {
    text-align: left;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    display: flex;
    gap: 0.5rem;
    padding: 0 0.5rem;
    color: #444;

    &:hover {
      background-color: #0001;
      cursor: pointer;
    }

    input[type="checkbox"] {
      accent-color: ${({ theme }) => theme.colors.primaryBlue.main};
    }
  }

  .last {
    padding: 0.5rem;
    &:hover {
      background-color: transparent;
      cursor: default;
    }
  }
`;

export const OrderButton = styled.button`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.primaryBlue.main} !important;
  display: flex;
  align-items: center;
  font-size: 1rem !important;
  gap: 0.6rem;

  &:hover {
    cursor: pointer;
    background-color: #fff3;
  }
  svg {
    color: ${({ theme }) => theme.colors.primaryPurple.main};
    font-weight: bold;
  }
`;
